import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactUs from '../Help/ContactUs';
import { helpUrls, HelpAction } from '../../lib/helpUrls';

export default function HelpSupport() {
  const navigate = useNavigate();
  const [showContactUs, setShowContactUs] = useState(false);

  const handleHelpAction = (action: HelpAction) => {
    switch (action) {
      case 'rulesPractices':
        window.open(helpUrls.termsAndConditions, '_blank', 'noopener,noreferrer');
        break;
      case 'patientPrivacy':
        window.open(helpUrls.patientPrivacy, '_blank', 'noopener,noreferrer');
        break;
      case 'communityGuidelines':
        window.open(helpUrls.communityGuidelines, '_blank', 'noopener,noreferrer');
        break;
      case 'faq':
        window.open(helpUrls.faq, '_blank', 'noopener,noreferrer');
        break;
      case 'contactUs':
        setShowContactUs(true);
        break;
      case 'aboutChime':
        window.open(helpUrls.aboutChime, '_blank', 'noopener,noreferrer');
        break;
      case 'aboutAdvita':
        window.open(helpUrls.aboutAdvita, '_blank', 'noopener,noreferrer');
        break;
      default:
        console.log('Unknown help action:', action);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 theme-surface">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold theme-text">Help & Support</h1>
        <button
          onClick={() => navigate('/settings')}
          className="theme-text-secondary hover:theme-text-primary p-2 transition-colors"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="space-y-4">
        <div className="theme-surface border rounded-lg overflow-hidden">
          <HelpItem
            title="Rules & Practices"
            onClick={() => handleHelpAction('rulesPractices')}
          />
          <HelpItem
            title="Patient Privacy"
            onClick={() => handleHelpAction('patientPrivacy')}
          />
          <HelpItem
            title="Community Guidelines"
            onClick={() => handleHelpAction('communityGuidelines')}
          />
          <HelpItem
            title="FAQ"
            onClick={() => handleHelpAction('faq')}
          />
          <HelpItem
            title="Contact Us"
            onClick={() => handleHelpAction('contactUs')}
          />
          <HelpItem
            title="About Chime"
            onClick={() => handleHelpAction('aboutChime')}
          />
          <HelpItem
            title="About Advita"
            onClick={() => handleHelpAction('aboutAdvita')}
          />
        </div>
      </div>

      {/* Contact Us Modal */}
      {showContactUs && (
        <ContactUs onClose={() => setShowContactUs(false)} />
      )}
    </div>
  );
}

interface HelpItemProps {
  title: string;
  onClick: () => void;
}

function HelpItem({ title, onClick }: HelpItemProps) {
  return (
    <div className="px-4 py-3 border-b theme-border-primary last:border-b-0">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium theme-text-primary">
          {title}
        </span>
        <button onClick={onClick} className="theme-text-secondary hover:theme-text-primary transition-colors">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}
